<template>
  <div class="overflow: auto">
    <Tree ref="tree" :data="treeData" @on-select-change="ConfigTree"></Tree>
    <Modal v-model="amend" title="修改权限">
      <div style="display: flex; justify-content: space-around">
        <Button
          style="
            background: green;
            border-color: green;
            padding: 10px 25px;
            font-size: 15px;
          "
          type="error"
          size="small"
          @click="Add = true"
          >添加节点</Button
        >
        <Button
          style="
            background: green;
            border-color: green;
            padding: 10px 25px;
            font-size: 15px;
          "
          type="error"
          size="small"
          @click="
            Config = true;
            update(id);
          "
          >修改节点</Button
        >
        <Button
          style="
            background: red;
            border-color: red;
            padding: 10px 25px;
            font-size: 15px;
          "
          type="error"
          size="small"
          @click="Delete = true"
          >删除节点</Button
        >
      </div>
    </Modal>
    <Modal v-model="Add" title="添加节点" @on-ok="AddNode">
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        角色名称：
      </div>
      <Input style="width: 200px" v-model="name" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        描述：
      </div>
      <Input style="width: 200px" v-model="description" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        权限标识：
      </div>
      <Input style="width: 200px" v-model="permissionCode" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        请求地址：
      </div>
      <Input style="width: 200px" v-model="targetUrl" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        顺序：
      </div>
      <Input style="width: 200px" v-model="sort" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        类型：
      </div>
      <Select value v-model="type" placeholder="选择类型" style="width: 200px">
        <Option v-for="item in types" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
    </Modal>
    <Modal v-model="Config" title="修改节点" @on-ok="AmendNode">
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        角色名称：
      </div>
      <Input style="width: 200px" v-model="selected[0].name" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        描述：
      </div>
      <Input style="width: 200px" v-model="selected[0].description" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        权限标识：
      </div>
      <Input style="width: 200px" v-model="selected[0].permissionCode" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        请求地址：
      </div>
      <Input style="width: 200px" v-model="selected[0].targetUrl" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        顺序：
      </div>
      <Input style="width: 200px" v-model="selected[0].sort" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">
        类型：
      </div>
      <Select
        value
        v-model="selected[0].type"
        placeholder="选择类型"
        style="width: 200px"
      >
        <Option v-for="item in types" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
    </Modal>
    <Modal v-model="Delete" title="删除节点" @on-ok="DeleteNode">
      <div style="text-align: center">是否删除节点？</div>
    </Modal>
  </div>
</template>

<script>
import { api } from "../biz/api";
import QRCode from "qrcodejs2";
export default {
  name: "jurisdiction",

  data() {
    return {
      Add: false,
      type: 0,
      id: "",
      name: "",
      description: "",
      permissionCode: "",
      targetUrl: "",
      sort: "",
      types: [
        {
          value: "0",
          label: "菜单",
        },
        {
          value: "1",
          label: "列表",
        },
        {
          value: "2",
          label: "按钮",
        },
      ],
      Delete: false,
      amend: false,
      Config: false,
      treeData: [],
      selected: [{}],
    };
  },
  activated: function () {
    this.getData();
  },
  mounted: function () {
    this.getData();
  },

  methods: {
    AddNode() {
      api
        .PermissionAdd({
          name: this.name,
          description: this.description,
          parentId: this.selected[0].id,
          type: this.type,
          permissionCode: this.permissionCode,
          targetUrl: this.targetUrl,
          sort: this.sort,
        })
        .then((data) => {
          this.getData();
          this.amend = false;
        });
    },
    AmendNode() {
      api.PermissionEdit(this.selected[0]).then((data) => {
        this.getData();
        this.amend = false;
      });
    },
    DeleteNode() {
      api.PermissionDel(this.selected[0].id).then((data) => {
        this.getData();
        this.amend = false;
      });
    },
    getData() {
      api.PermissionListTree(0).then((data) => {
        this.formatting(data.body.data);
        this.treeData = [
          {
            children: data.body.data,
            expand: true,
            selected: false,
            title: "全部",
          },
        ];
      });
    },
    formatting(data) {
      data.forEach((element) => {
        if (element.child) {
          element.children = element.child;
          this.formatting(element.children);
        }

        element.expand = true;
        element.selected = false;
        element.title = element.name;
      });
    },
    update(id) {
      api.PermissionGet(id).then((data) => {
        this.selected = [data.body.data];
        this.$forceUpdate();
      });
    },
    ConfigTree(res) {
      this.amend = true;
      if (res.length != 0) {
        if (res[0].id) {
          this.id = res[0].id;
          api.PermissionGet(res[0].id).then((data) => {
            this.selected = [data.body.data];
            this.$forceUpdate();
          });
        } else {
          this.id = "";
        }
      }
    },
  },
};
</script>

<style scoped lang = 'less'>
</style>